export const hidePolygon = (zoneDisplayed, setZoneDisplayed) => {
    for (let i = 0; i < zoneDisplayed.length; i++) {
      zoneDisplayed[i]?.setMap(null);
    }
    setZoneDisplayed([]);
  };
